import { makeStyles } from "@material-ui/core";
import { Theme } from '@material-ui/core/styles';
import { NoEncryption } from "@material-ui/icons";

const drawerWidth = 320;

export default makeStyles((theme: Theme) => ({
    content: {
        [theme.breakpoints.up('sm')]: {
            paddingRight: drawerWidth,
        }
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    sidebarTitle: {
      color: '#428302',
      marginLeft: '5px'
    },
    gridContainer: {
      width: '100%'
    },
    paper: {
      paddingLeft: '25px',
      paddingRight: '25px',
      paddingBottom: '20px'
    },
    paperHeader: {
      padding: '0',
      flexDirection: 'row-reverse'
    },
    paperHeaderIcon:{
      color: '#428302'
    },
    selectInput: {
      width:'100%',
      paddingRight: '20px!important'
    },
    saveButton: {
        float: "right",
        backgroundColor: '#107A98',
        '&:hover': {
            backgroundColor: '#004763!important',
        }
    },
    hideComponent: {
      display: 'none'
    }
}));